import { createAction, handleActions } from 'redux-actions';

const loadValuation = createAction("SCREENS/VALUATION_VIEW/LOAD_VALUATION");
const clearValuation = createAction("SCREENS/VALUATION_VIEW/CLEAR_VALUATION");
const updateCertificateAmount = createAction("SCREENS/VALUATION_VIEW/UPDATE_CERTIFICATE_AMOUNT");

const defaultState = null

const reducer = handleActions(
  {
    [loadValuation]: (state, action) => action.payload,
    [clearValuation]: () => null,
    [updateCertificateAmount]: (state, action) => action.payload
  },
  defaultState
);

export { loadValuation, clearValuation, updateCertificateAmount, reducer };